import { Injectable } from '@angular/core';

@Injectable()
export class WindowLocationService {
  public getHref(): string {
    return window.location.href;
  }

  public setHref(href: string): void {
    window.location.href = href;
  }
}
